import type { routes } from '@semios/app-platform-banyan-route-definitions'
import { isEmpty, isNil } from '@semios/app-platform-common'
import { propertyLacksPermissionSectionMaker } from 'App/Map/PanelDetails/_utils/propertyLacksPermissionSectionMaker'
import { selectedPropertyHasPermission } from 'App/Map/PanelDetails/_utils/selectedPropertyHasPermission'
import type { GridTableContentSection } from 'components/GridTable/types'
import { translate } from 'i18n/i18n'
import type { TPoint } from 'stores/fieldAssetStore/helperTypes'
import { DropdownSelectorPropertyFlowMeter } from '../flowMeter/DropdownSelectorPropertyFlowMeter'
import { CumulativeSummaryTable } from './CumulativeSummaryTable'

const checkPermission = () =>
  selectedPropertyHasPermission({ permission: 'VIEW_IRRIGATION_FLOW_METER_DETAILS' })

const getSummaryTableHeight = (points: TPoint[]) => {
  if (isEmpty(points) || isNil(points)) return 0

  const numberOfItems = Object.values(points).length
  const fixedHeight = 185
  const itemHeight = 39

  return numberOfItems * itemHeight + fixedHeight
}

export const flowMeterTotals = ({
  data,
  points,
}: {
  data: routes.Values.Response
  points: TPoint[]
}): GridTableContentSection => {
  const title = translate.phrases.banyanApp('Flow Meter Totals')

  const commonReturnItems = {
    title,
    fieldAssetPicker: <DropdownSelectorPropertyFlowMeter />,
    id: 'summary-grid-flowMeter-totals',
  }

  if (!checkPermission() || points.length === 0) return propertyLacksPermissionSectionMaker(commonReturnItems)

  const flowMeterData = Object.fromEntries(
    Object.entries(data.points || {}).filter(
      ([, flowMeterValues]) => (flowMeterValues?.values?.irrigationFlowMeter || []).length > 0,
    ),
  )

  return {
    title,
    fieldAssetPicker: <DropdownSelectorPropertyFlowMeter />,
    id: 'summary-grid-flowMeter-totals',
    belowFullWidthItems: [
      {
        height: getSummaryTableHeight(points),
        content: <CumulativeSummaryTable points={points} data={flowMeterData} />,
      },
    ],
  }
}
